import React from "react";

export const Space = (props) => {
  const { settings } = props;
  const { divider } = settings;
  return (
    <div className="cms-space" style={{ width: "100%" }}>
      {divider ? <hr style={{ width: "unset" }} /> : null}
    </div>
  );
};
